// extracted by mini-css-extract-plugin
module.exports = {"blog":"single-blog-module--blog--3eSkn","center":"single-blog-module--center--NlKNV","post":"single-blog-module--post--3q_1e"};